import { RatePlanMerged } from "@/helpers/interfaces/RatePlanMerged.ts";
import { EngineStoreData } from "@/stores/EngineStore/EngineStore.ts";
import { createCAItem } from "@/stores/EngineStore/helpers/createCAItem.ts";

export const addCartItemHelper = (state: EngineStoreData, ratePlan: RatePlanMerged) => {
  const isOccupancyLessThanDefault = ratePlan.occupancy < state.defaultAdults;
  const adultsCount = isOccupancyLessThanDefault ? 1 : state.defaultAdults;

  return {
    ...state,
    cartAccommodationItems: [
      ...state.cartAccommodationItems,
      createCAItem(ratePlan, adultsCount, state.defaultDateRange),
    ],
  };
};
